<template>
    <div>
       <backTitleBar :isBackHome="true"></backTitleBar>
        <div class="shop-info" style="background: #1FC581;">
            <div class="info-item">
                <div class="title">累积销售金额(元)</div>
                <div class="number number_font">{{formatNumber(salesMoney || 0)}}</div>
                <div class="zuori number_font">昨日金额 {{formatNumber(salesMoneyY || 0)}}</div>
            </div>
            <div class="info-item">
                <div class="title">累计订单</div>
                <div class="number number_font">{{formatNumber(orderNum || 0)}}</div>
            </div>
        </div>
        <div class="page-flex">
            <div class="page-data">
              <div>
                  <div class="page-text-d">销售额(元)</div>
              </div>
              <div id="myChart" :style="{width: '7.5rem', height: '5rem', top:'-.6rem'}"></div>
            </div>

            <div class="page-user">
              <div>
                  <div class="page-text-d">销售概况(元)</div>
              </div>
              <div class="page-data-top">
                     <div class="page-data-div" :class="tabTimeActive == item.value ?'active':''" v-for="item in tabTimeList" :key="item.value" @click="tabTimeActive = item.value">{{item.name}}</div>
                 </div>
                 <DatePicker v-show="tabTimeActive == 3" :editable=false @on-change="timeChange" type="date" :value="time" class="page-data-time" placement="top-start"  placeholder="请选择日期" style="width: 3.47rem"></DatePicker>
                 <DatePicker v-show="tabTimeActive == 2" :editable=false @on-change="timeChange" type="month" :value="time" class="page-data-time" placement="top-start"  placeholder="请选择日期" style="width: 3.47rem"></DatePicker>
                 <DatePicker v-show="tabTimeActive == 1" :editable=false @on-change="timeChange" type="year" :value="time" class="page-data-time" placement="top-start"  placeholder="请选择日期" style="width: 3.47rem"></DatePicker>
              <div id="myChart2" :style="{width: '7.4rem' , height:'3.92rem', right:'2.8rem', bottom:'.44rem', left:'.01rem'}"></div>
            </div>
        </div>
        <tabber :tabActive="0"></tabber>
    </div>
</template>

<script>
    import routerBack from "@/mixins/routerBack"
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {qrySaleByDimension} from "@/api/data"
    import tabber from '@/view/data/product/index'
    import getAppParams from "@/mixins/getAppParams";
    import getAppStatusHeight from "@/mixins/getAppStatusHeight";
    export default {
        name: "marketingDaily",
        mixins: [routerBack,getAppParams,getAppStatusHeight],
        components:{tabber, backTitleBar},
        data(){
            return{
                modal1: false,
                tabTimeList:[
                    {name:'日',value: 3},
                    {name:'月',value: 2},
                    {name:'年',value: 1}
                ],
                tabTimeActive: 3,
                time:'',
                salesMoney: '',
                orderNum: '',
                salesMoneyY: '',
                today: [],
                yesday: [],
                dayA: [],
                salesMoneyA: [],
                dayTime: ["0:00","1:00","2:00","3:00","4:00","5:00","6:00","7:00","8:00","9:00","10:00","11:00","12:00","13:00","14:00","15:00","16:00","17:00","18:00","19:00","20:00","21:00","22:00","23:00"]
            }
        },
        watch:{
            tabTimeActive(val){
                if(val){

           let temp_date = new Date();
           let temp_year1 = temp_date.getFullYear();
           let temp_month1 = (temp_date.getMonth()+1) > 9 ? (temp_date.getMonth()+1) : "0" + (temp_date.getMonth()+1);
           let temp_day1 = (temp_date.getDate()) > 9 ? (temp_date.getDate()) : "0" + (temp_date.getDate());
           let curTime = temp_year1.toString() + temp_month1.toString() + temp_day1.toString();
           let curTime2 = temp_year1.toString() + temp_month1.toString();
           let curTime3 = temp_year1.toString()
           let time = temp_date.toLocaleDateString().split('/').join('-');
           this.time = val == 3 ? curTime : val == 2 ? curTime2 : curTime3;

                    let params4 = {
                        curTime: val == 3 ? curTime : val == 2 ? curTime2 : curTime3,
                        dimension: val,
                        qryFlag: 0,
                        dataType: 5
                      }
                   qrySaleByDimension(params4).then(res=>{
                      if(res.code == 0){
                        let dayA = [];
                        let salesMoneyA = [];
                       res.data.records.forEach(params => {
                           if(params.day){
                              dayA.push(params.day)
                            }else if(params.month){
                              dayA.push(params.month)
                            }else if(params.year){
                              dayA.push(params.year)
                            }
                       salesMoneyA.push(params.salesMoney)
                       });
                         this.dayA = dayA
                         this.salesMoneyA = salesMoneyA
                         this.drawLine();
                      }
                    })
                }
            }
        },
        mounted(){
           let _this = this;
           let temp_date = new Date();
           let temp_year1 = temp_date.getFullYear();
           let temp_month1 = (temp_date.getMonth()+1) > 9 ? (temp_date.getMonth()+1) : "0" + (temp_date.getMonth()+1);
           let temp_day1 = (temp_date.getDate()) > 9 ? (temp_date.getDate()) : "0" + (temp_date.getDate());
           let curTime = temp_year1.toString() + temp_month1.toString() + temp_day1.toString();
           let time = temp_date.toLocaleDateString().split('/').join('-');
           this.time = time;

           let params = {
              curTime: curTime,
              dimension: 3,
              qryFlag: 3,
              dataType: 5
           }
           qrySaleByDimension(params).then(res=>{
               if(res.code == 0){
                  this.salesMoney = res.data.records[0].salesMoney
                  this.orderNum = res.data.records[0].orderNum
               }
           })

           let params2 = {
              curTime: curTime,
              dimension: 3,
              qryFlag: 2,
              dataType: 5
           }
           qrySaleByDimension(params2).then(res=>{
               if(res.code == 0){
                  this.salesMoneyY = res.data.records[0].salesMoney
               }
           })

           let params3 = {
              curTime: curTime,
              dimension: 3,
              qryFlag: 1,
              dataType: 5
           }
           qrySaleByDimension(params3).then(res=>{
               if(res.code == 0){
                   //let today =  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
                   //let yesday = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
                   let today = []
                   let yesday = []

                //    res.data.records.forEach(params => {
                //        if(params.day == curTime){
                //               today[params.hour] = params.salesMoney
                //        }else{
                //               yesday[params.hour] = params.salesMoney
                //        }
                //    });

                   res.data.records.forEach(params => {
                       if(params.day == curTime){
                              today.push(params.salesMoney)
                       }else{
                              yesday.push(params.salesMoney)
                       }
                   });

                //    let params = res.data.records
                //    let params2 = _this.dayTime
                //    for (let i = 0; i < res.data.records.length; i++) {
                //        for (let j = 0; j < _this.dayTime.length; j++) {
                //           if(params[i].day == curTime){
                //            if(params[i].hour == params2[j].split(':')[0]){
                //               today.push(params[i].salesMoney)
                //            }
                //            else{
                //               today.push(0)
                //            }
                //        }else{
                //            if(params[i].hour == params2[j].split(':')[0]){
                //               yesday.push(params[i].salesMoney)
                //            }
                //            else{
                //               yesday.push(0)
                //            }
                //        }

                //        }
                //    }
                  this.today = today
                  this.yesday = yesday
                  this.drawLine();
               }
           })

           let params4 = {
              curTime: curTime,
              dimension: 3,
              qryFlag: 0,
              dataType: 5
           }
           qrySaleByDimension(params4).then(res=>{
               if(res.code == 0){
                  let dayA = [];
                  let salesMoneyA = [];
                   res.data.records.forEach(params => {
                       dayA.push(params.day)
                       salesMoneyA.push(params.salesMoney)
                   });
                  this.dayA = dayA
                  this.salesMoneyA = salesMoneyA
                  this.drawLine();
               }
           })
           window.addEventListener('resize',()=>{
                this.$echarts.init(document.getElementById('myChart')).resize()
                this.$echarts.init(document.getElementById('myChart2')).resize()
            })
        },
        methods: {
           timeChange(e){
             this.times = e;
            if(e){
            let time = e.split('-').join('');
            let params4 = {
              curTime:  time,
              dimension: this.tabTimeActive,
              qryFlag: 0,
              dataType: 5
            }
           qrySaleByDimension(params4).then(res=>{
               if(res.code == 0){
                  let dayA = [];
                  let salesMoneyA = [];
                   res.data.records.forEach(params => {
                       if(params.day){
                         dayA.push(params.day)
                       }else if(params.month){
                         dayA.push(params.month)
                       }else if(params.year){
                         dayA.push(params.year)
                       }
                       salesMoneyA.push(params.salesMoney)
                   });
                  this.dayA = dayA
                  this.salesMoneyA = salesMoneyA
                  this.drawLine();
               }
             })
            }
           },
           check(){
               if(!this.times){
                   this.$Message.info('请选择日期');
                   return
               }
               this.time = this.times;
               this.modal1 = false
           },
           drawLine(){
           // 基于准备好的dom，初始化echarts实例
              let myChart = this.$echarts.init(document.getElementById('myChart'));
              let myChart2 = this.$echarts.init(document.getElementById('myChart2'))
           // 绘制图表
               let _this = this;
               myChart.setOption({
                   legend: {
                     data: ['今天', '昨天'],
                     right: '3%',
                     icon: 'circle'
                    },
                  tooltip: {
                      trigger: 'axis',
                  },
                  grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                  },
                  xAxis: {
                      boundaryGap: true,
                      axisTick: {
                          show: false
                      },
                      data: _this.dayTime
                  },
                  yAxis: [
                       {
                         type : 'value',
                         boundaryGap: true,
                         axisTick: {
                          show: false
                         },
                       }
                  ],
                  series: [
                    {
                     name: '今天',
                     type: 'line',
                     //areaStyle: {normal: {color:'#1FC581'}},
                     lineStyle: {normal: {width: 3}},
                     data: _this.today,
                     showSymbol: false
                    },
                    {
                     name: '昨天',
                     type: 'line',
                     //areaStyle: {normal: {color:'rgba(255, 132, 15, 0.05)'}},
                     lineStyle: {normal: {width: 3}},
                     data: _this.yesday,
                     showSymbol: false
                  }
                  ],
                  color:['#1FC581','rgb(253,118,12)']
               });

               myChart2.setOption({
                  color: ['#1FC581'],
                  tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                       type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                  },
                  grid: {
                   left: '3%',
                   right: '4%',
                   bottom: '3%',
                   containLabel: true
                  },
                xAxis: [
                   {
                     type: 'category',
                     data: _this.dayA,
                     axisTick: {
                         alignWithLabel: true
                      }
                   }
                 ],
              yAxis: [
                 {
                   type: 'value'
                 }
               ],
             series: [
                {
                  name: '销售额',
                  type: 'bar',
                  barWidth: '60%',
                  data: _this.salesMoneyA
                }
              ]
            });
            //    window.addEventListener("resize", function () {
            //       setTimeout(function () {
            //         myChart.resize();
            //         myChart2.resize();
            //       }, 500)
            //  });
            }

         }
    }
</script>

<style scoped lang="scss">
    .shop-top{
        display: flex;
        flex-direction: row;
        margin: .2rem 0;
        .shopName{
            color: #eee;
            font-size: .32rem;
            line-height: .45rem;
            padding-bottom: .05rem;
            margin-bottom: .05rem;
            margin-left: .4rem;
        }
        .active{
            color: #fff;
            border-bottom: .05rem solid #fff;
        }
    }
    .shop-info{
        padding-left: .6rem;
        padding-top: .37rem;
        padding-bottom: .32rem;
        display: flex;
        flex-direction: row;
        .zuori{
            font-size: .24rem;
            font-weight: 400;
            line-height: .47rem;
            width: 2.52rem;
            height: .47rem;
            background: rgba(0,0,0,0.1);
            border-radius: .27rem;
            margin-left: -.17rem;
            text-align: center;
        }
        .shopName{
            color: #eee;
            font-size: .32rem;
            line-height: .45rem;
            padding-bottom: .05rem;
            margin-bottom: .15rem;
            margin-left: .4rem;

        }
        .active{
            color: #fff;
            border-bottom: .05rem solid #fff;
        }
        .info-item{
            color: #fff;
            .title{
                color: #eee;
                font-size: .26rem;
                line-height: .4rem;
            }
            .number{
                padding-top: .11rem;
                font-size: .52rem;
            }
            &:first-child{
                width: 65%;
            }
            &:nth-child(2){
                width: 35%;
            }
        }
    }
    .page-flex{
        background: #fff;
        border-radius: .24rem;
        .page-data{
            background: #fff;
            height: 6rem;
            border-radius: .24rem;
        }
        .page-user{
            background: #fff;
            height: 4.9rem;
            border-radius: .24rem;
        }
        .datas{
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            padding: .2rem .6rem;
            margin-top: .8rem;
        }
        .page-text-r{
            width: 2.2rem;
            height: .6rem;
            margin-top: .2rem;
            margin-left: 2.8rem;
            z-index: 9999;
        }
        .datas-text{
            margin-right: .4rem;
            margin-bottom: .1rem;
            flex: auto;
        }
        .datas-top{
           font-size: .4rem;
           font-weight: bold;
           color: #FD760C;
           text-align: center
        }
        .datas-bottom{
            font-size: .28rem;
            text-align: center
        }
        .page-text-d{
           float: left;
           font-size: .34rem;
           font-weight: bold;
           margin: .28rem .28rem;
           border-left: .04rem solid #1FC581;
           padding-left: .1rem;
        }
        .page-text-t{
           float: right;
           margin: .28rem .38rem;
           span{
               padding-left: .2rem;
           }
           span.active{
               color: #1FC581;
               font-weight: bold;
           }
        }
    }
    .page-data-time{
        display: block;
        margin: 0 auto;
    }
    .page-data-top{
        width: 94%;
        height: .68rem;
        display: flex;
        flex-direction: row;
        margin: .3rem .24rem;
        border-radius: .12rem;
        border: .03rem solid #1FC581;
    }
    .page-data-div{
        flex: auto;
        font-size: .28rem;
        text-align: center;
        line-height: .68rem;
        &:first-child{
          border-right: .03rem solid #1FC581;
        }
        &:nth-child(2){
          border-right: .03rem solid #1FC581;
        }
        &.active{
            color: #fff;
            background: #1FC581;
        }
    }
</style>



// WEBPACK FOOTER //
// marketingDaily.vue?28655ff2